/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75290Req {
  
  /**  */
  taskId?: string;
};



export interface API75290Res {
  /** 任务状态  */
  taskStatus?: string;
  /** 语音转文字结果  */
  content?: string;
  
};


// 接口函数 75290 查询语音文件转换结果

export interface IUsePostAPI75290Return {
  /** 查询语音文件转换结果: 接口请求状态 */
  isAPI75290Loading: boolean;
  /** 查询语音文件转换结果: 接口请求返回数据 */
  dataAPI75290: API75290Res;
  /**  查询语音文件转换结果: 接口数据请求方法 */
  fetchAPI75290Data: (inputs: API75290Req, config?: YWRequestConfig) => Promise<API75290Res>;
  /** 查询语音文件转换结果: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75290 = ():IUsePostAPI75290Return => {
  let isMount = true;
  const [isAPI75290Loading, setIsAPI75290Loading] = useState(false);
  const [dataAPI75290, setDataAPI75290] = useState<API75290Res>({} as API75290Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/queryVoiceFile`;

  const fetchAPI75290Data = async (inputs: API75290Req, config?: YWRequestConfig): Promise<API75290Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75290Req>) || {}) as API75290Req;
    
  
    if ( isMount ) {
      setIsAPI75290Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75290Res>(`${basePath}/yoaichat-web/chat/meeting/queryVoiceFile`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75290(res || {} as API75290Res);
        setIsAPI75290Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75290Loading(false);
      }
      return false as unknown as API75290Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75290Loading,
    dataAPI75290,
    fetchAPI75290Data,
    requestUrl,
  }
}

